/*
 * Browser shim for `typeorm` (server-only ORM).
 *
 * Web imports api/src entities/DTOs for their shapes, constants and `.toPublic()` helpers.
 * Those entities are decorated with typeorm (@Entity, @Column, @ManyToOne, ...), which drags
 * the real typeorm package (~50 KB) into the browser bundle even though web never runs any
 * ORM code. This stub neutralizes every typeorm export:
 *   - decorators (@Column(), @Entity(), ...) become no-ops, so class definitions are unaffected;
 *   - values (operators like Not/In, SelectQueryBuilder, Repository) resolve to a harmless no-op.
 * Nothing here is ever executed in the browser — the code paths that would use it are server-only.
 */

function noop() {}

// Decorator factory / operator: calling it returns a no-op decorator that returns `undefined`
// (important so class decorators don't accidentally replace the decorated class).
function stub() {
	return noop;
}

var handler = {
	get: function (target, prop) {
		if (prop === '__esModule') return true;
		if (prop === 'default') return proxy;
		if (typeof prop === 'symbol') return undefined;
		return stub;
	}
};

// Target is a function, so the proxy stays callable/constructable if ever referenced that way.
var proxy = new Proxy(function () {}, handler);

module.exports = proxy;
